import { MaybeUndef } from "types/UtilityTypes";

export default function isEmptyStringOrNull(str: MaybeUndef<string>): boolean {
  return str == null || str.length === 0;
}
